export const WorkspaceRequestInit = {
    workspaceDescription: "",
    workspaceName: "",
    workspaceSubscriptionPlanId: 0,
};
